import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * CustomDefinirOperariosPicking
 **/
class CustomDefinirOperariosPicking extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal                                  = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged']           = this.onSelectionChangedPrincipal;

        this.gridOptionsAux = Object.assign({}, this.gridOptions);
        this.onSelectionChangeVacio                                  = this.onSelectionChangeVacio.bind(this);

        this.gridOptionsAux['onSelectionChanged']           = this.onSelectionChangedPrincipal;

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);

        this.consultarPicking = this.consultarPicking.bind(this);
        this.sucessconsultarPicking = this.sucessconsultarPicking.bind(this);
        this.traerUbicaciones = this.traerUbicaciones.bind(this);
        this.sucesstraeUbicaciones = this.sucesstraeUbicaciones.bind(this);
        this.traerEstados = this.traerEstados.bind(this);
        this.sucesstraeEstados = this.sucesstraeEstados.bind(this);
        this.traerOperariosPicking = this.traerOperariosPicking.bind(this);
        this.sucesstraerOperariosPicking = this.sucesstraerOperariosPicking.bind(this);
        this.crearPicking = this.crearPicking.bind(this);
        this.successCrearPicking = this.successCrearPicking.bind(this);


        this.traerOperarios = this.traerOperarios.bind(this);
        this.sucessTraerOperarios = this.sucessTraerOperarios.bind(this);
        this.traerTurnos = this.traerTurnos.bind(this);
        this.traerTurnos = this.traerTurnos.bind(this);
        this.sucessTurnos = this.sucessTurnos.bind(this);
        this.traerEmpacadores = this.traerEmpacadores.bind(this);
        this.sucessEmpacadores = this.sucessEmpacadores.bind(this);

        this.crearEmpacador = this.crearEmpacador.bind(this);
        this.successcrearEmpacador = this.successcrearEmpacador.bind(this);
        this.crearOperario = this.crearOperario.bind(this);
        this.successcrearOperario = this.successcrearOperario.bind(this);
        this.crearTurno = this.crearTurno.bind(this);
        this.successcrearTurno = this.successcrearTurno.bind(this);

        this.traerEmpacadorCodigo = this.traerEmpacadorCodigo.bind(this);
        this.sucesstraerEmpacadorCodigo = this.sucesstraerEmpacadorCodigo.bind(this);
        this.traerOperarioCodigo = this.traerOperarioCodigo.bind(this);
        this.sucesstraerOperarioCodigo = this.sucesstraerOperarioCodigo.bind(this);
        this.traerTurnoCodigo = this.traerTurnoCodigo.bind(this);
        this.sucesstraerTurnoCodigo = this.sucesstraerTurnoCodigo.bind(this);

        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
        this.valor_anterior='';
    }

    initForm() {
        console.log('Formulario CustomDefinirOperariosPicking,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();
        this.traerUbicaciones();
        this.traerEstados();

        this.getField('select_ubicaciones').setOnChange((props) => {
            this.getField('select_ubicaciones').setError(false,'');
            this.limpiarCampos();
            if(this.getField('select_ubicaciones').getValue()!=='' && this.getField('select_ubicaciones').getValue()!==' ')
                this.consultarPicking();
        });

 
        this.getField('bt_crear').setClick(()=>{
            this.crearPicking();

        });


        this.getField('bt_crear_operario').setClick(()=>{
            this.valor_anterior='';
            this.getField('modal_operador').handleClickOpen();
            this.traerOperarios();
        });

        //refrescar select operarios
        this.getField('modal_operador').setCloseButton(this.traerOperariosPicking);


        this.getField('bt_crear_turno').setClick(()=>{
            this.valor_anterior='';
            this.getField('modal_turnos').handleClickOpen();
            this.traerTurnos()
        });
        //refrescar picking --> turnos  rejilla principal
        this.getField('modal_turnos').setCloseButton(this.consultarPicking);



        this.getField('bt_crear_empacador').setClick(()=>{
            this.valor_anterior='';
            this.getField('modal_empacadores').handleClickOpen();
            this.traerEmpacadores()
        });

        //crear------------->
        this.getField('bt_grabar_operario').setClick(()=>{
            this.crearOperario()
        });

        this.getField('bt_crear_turno2').setClick(()=>{
            this.crearTurno()
        });

        this.getField('bt_crear_empacador2').setClick(()=>{
            this.crearEmpacador()
        });

        //onchage codigo------------->
        this.getField('codigo_operario').setOnChange(()=>{
            this.getField('nombre_operario').setError(false,'');
            this.getField('select_estado_operario').setError(false,'');
            this.getField('nombre_operario').setValue('');
            this.getField('select_estado_operario').setValue('');

        });
        this.getField('codigo_operario').setOnBlur(()=>{
            if(this.valor_anterior==='' || this.getField('codigo_operario').getValue()!==this.valor_anterior){
                this.valor_anterior=this.getField('codigo_operario').getValue().toString().trim();
                if(this.getField('codigo_operario').getValue().toString().trim()!=='')
                    this.traerOperarioCodigo();
            }
        });

        this.getField('codigo_turno').setOnChange(()=>{
            this.getField('detalle_turno').setError(false,'');
            this.getField('detalle_turno').setValue('');
        });
        this.getField('codigo_turno').setOnBlur(()=>{
            if(this.valor_anterior==='' || this.getField('codigo_turno').getValue()!==this.valor_anterior){
                this.valor_anterior=this.getField('codigo_turno').getValue().toString().trim();
                if(this.getField('codigo_turno').getValue().toString().trim()!=='')
                    this.traerTurnoCodigo();
            }
        });


        this.getField('codigo_empacador').setOnChange(()=>{
            this.getField('nombre_empacador').setError(false,'');
            this.getField('select_ubicaciones2').setError(false,'');
            this.getField('select_estado_empacadador').setError(false,'');

            this.getField('nombre_empacador').setValue('');
            this.getField('select_ubicaciones2').setValue('');
            this.getField('select_estado_empacadador').setValue('');
        });
        this.getField('codigo_empacador').setOnBlur(()=>{
            if(this.valor_anterior==='' || this.getField('codigo_empacador').getValue()!==this.valor_anterior){
                this.valor_anterior=this.getField('codigo_empacador').getValue().toString().trim();
                if(this.getField('codigo_empacador').getValue().toString().trim()!=='')
                    this.traerEmpacadorCodigo();
            }
        });



    }

    crearOperario() {
        if(this.getField('codigo_operario').valid() && this.getField('nombre_operario').valid()
            && this.getField('select_estado_operario').valid()){
            this.mostrarMensajeGuardando();
            let datos = {
                datos: {
                    codigo_operario: this.getField("codigo_operario").getValue(),
                    nombre_operario: this.getField("nombre_operario").getValue(),
                    select_estado_operario: this.getField("select_estado_operario").getValue(),
                    sucursal_ingreso:this.sucursal_ingreso,
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearoperario', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successcrearOperario,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    successcrearOperario(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if(data.data.mensaje_mostrar!==undefined && data.data.input!==undefined && data.data.pedir_clave!==undefined && data.data.pedir_clave===true){//nuevo necesita clave
                this.getField('confirmModalCustom').setTitleAndContent('Operarios', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                        this.getField('confirmModalCustom').toggle(false); 
                        this.getField('modal_clave').handleClickOpen();
                        this.getField('bt_cancelar_clave').setClick(()=>{
                            this.getField('modal_clave').handleClose();
                        });
                        this.getField('bt_aceptar_clave').setClick(()=>{
                            if(this.getField('clave').valid()){
                                this.clave = this.getField('clave').getValue();
                                this.getField('modal_clave').handleClose();
                                this.mostrarMensajeGuardando();
                                let datos = {
                                    datos: {
                                        codigo_operario: this.getField("codigo_operario").getValue(),
                                        nombre_operario: this.getField("nombre_operario").getValue(),
                                        select_estado_operario: this.getField("select_estado_operario").getValue(),
                                        sucursal_ingreso:this.sucursal_ingreso,
                                        input:'1',
                                        clave:this.clave,
                                    }
                                }
                                this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearoperario', operacion_tipo: 'crear' };
                                this.service.send(
                                {
                                    endpoint: this.constant.formConfiguration(),
                                    method: 'POST',
                                    body: datos,
                                    success: this.successcrearOperario,
                                    error: this.error_,
                                    general: this.generalFormatPmv,
                                    showMessage: false
                                });
                            }
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Confirmar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if(data.data.mensaje_mostrar!==undefined && data.data.input!==undefined && data.data.input===true){//ya existe entonces va a  modificar
                this.getField('confirmModalCustom').setTitleAndContent('Operarios', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                        this.mostrarMensajeGuardando();
                        let datos = {
                            datos: {
                                codigo_operario: this.getField("codigo_operario").getValue(),
                                nombre_operario: this.getField("nombre_operario").getValue(),
                                select_estado_operario: this.getField("select_estado_operario").getValue(),
                                sucursal_ingreso:this.sucursal_ingreso,
                                input:'1',
                                clave:this.clave,
                            }
                        }
                        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearoperario', operacion_tipo: 'crear' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successcrearOperario,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }else{
                //refrescar tabla
                this.getField("codigo_operario").setValue('');
                this.getField("nombre_operario").setValue('');
                this.getField("select_estado_operario").setValue('');
                this.alertGeneral.toggle(true, 'Operación realiza con éxito.', 'success');
                this.traerOperarios();
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        };
    }

    crearEmpacador() {
        if(this.getField('codigo_empacador').valid() && this.getField('nombre_empacador').valid()
            && this.getField('select_ubicaciones2').valid()
            && this.getField('select_estado_empacadador').valid()){
            this.mostrarMensajeGuardando();
            let datos = {
                datos: {
                    codigo_empacador: this.getField("codigo_empacador").getValue(),
                    nombre_empacador: this.getField("nombre_empacador").getValue(),
                    select_ubicaciones2: this.getField("select_ubicaciones2").getValue(),
                    select_estado_empacadador: this.getField("select_estado_empacadador").getValue(),
                    sucursal_ingreso:this.sucursal_ingreso,
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearempacador', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successcrearEmpacador,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    successcrearEmpacador(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if(data.data.mensaje_mostrar!==undefined && data.data.input!==undefined && data.data.pedir_clave!==undefined && data.data.pedir_clave===true){//nuevo necesita clave
                this.getField('confirmModalCustom').setTitleAndContent('Empacadores', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                        this.getField('confirmModalCustom').toggle(false);
                        this.getField('modal_clave').handleClickOpen();
                        this.getField('bt_cancelar_clave').setClick(()=>{
                            this.getField('modal_clave').handleClose();
                        });
                        this.getField('bt_aceptar_clave').setClick(()=>{
                            if(this.getField('clave').valid()){
                                this.clave=this.getField('clave').getValue();
                                this.getField('modal_clave').handleClose();
                                this.mostrarMensajeGuardando();
                                let datos = {
                                    datos: {
                                        codigo_empacador: this.getField("codigo_empacador").getValue(),
                                        nombre_empacador: this.getField("nombre_empacador").getValue(),
                                        select_ubicaciones2: this.getField("select_ubicaciones2").getValue(),
                                        select_estado_empacadador: this.getField("select_estado_empacadador").getValue(),
                                        sucursal_ingreso:this.sucursal_ingreso,
                                        input:'1',
                                        clave:this.clave,
                                    }
                                }
                                this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearempacador', operacion_tipo: 'crear' };
                                this.service.send(
                                {
                                    endpoint: this.constant.formConfiguration(),
                                    method: 'POST',
                                    body: datos,
                                    success: this.successcrearEmpacador,
                                    error: this.error_,
                                    general: this.generalFormatPmv,
                                    showMessage: false
                                });
                            }
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Confirmar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if(data.data.mensaje_mostrar!==undefined && data.data.input!==undefined && data.data.input===true){//ya existe entonces va a  modificar
                this.getField('confirmModalCustom').setTitleAndContent('Empacadores', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                        this.mostrarMensajeGuardando();
                        let datos = {
                            datos: {
                                codigo_empacador: this.getField("codigo_empacador").getValue(),
                                nombre_empacador: this.getField("nombre_empacador").getValue(),
                                select_ubicaciones2: this.getField("select_ubicaciones2").getValue(),
                                select_estado_empacadador: this.getField("select_estado_empacadador").getValue(),
                                sucursal_ingreso:this.sucursal_ingreso,
                                input:'1',
                            }
                        }
                        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearempacador', operacion_tipo: 'crear' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successcrearEmpacador,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }else{
                //refrescar tabla
                this.getField("codigo_empacador").setValue('');
                this.getField("nombre_empacador").setValue('');
                this.getField("select_ubicaciones2").setValue('');
                this.getField("select_estado_empacadador").setValue('');
                this.alertGeneral.toggle(true, 'Operación realiza con éxito.', 'success');
                this.traerEmpacadores();
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        };
    }

    crearTurno() {
        if(this.getField('codigo_turno').valid() && this.getField('detalle_turno').valid()){
            this.mostrarMensajeGuardando();
            let datos = {
                datos: {
                    codigo_turno: this.getField("codigo_turno").getValue(),
                    detalle_turno: this.getField("detalle_turno").getValue(),
                    sucursal_ingreso:this.sucursal_ingreso,
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearturno', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successcrearTurno,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    successcrearTurno(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if(data.data.mensaje_mostrar!==undefined && data.data.input!==undefined && data.data.input===true){
                this.getField('confirmModalCustom').setTitleAndContent('Turnos', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                        this.mostrarMensajeGuardando();
                        let datos = {
                            datos: {
                                codigo_turno: this.getField("codigo_turno").getValue(),
                                detalle_turno: this.getField("detalle_turno").getValue(),
                                sucursal_ingreso:this.sucursal_ingreso,
                                input:'1',
                            }
                        }
                        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'crearturno', operacion_tipo: 'crear' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successcrearTurno,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }else{
                //refrescar tabla
                this.getField("codigo_turno").setValue('');
                this.getField("detalle_turno").setValue('');
                this.alertGeneral.toggle(true, 'Operación realiza con éxito.', 'success');
                this.traerTurnos();
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        };
    }

    crearPicking() {
        if(this.getField('select_ubicaciones').valid() && this.getField('select_operario').valid()){
            if(this.fila_seleccionada.length>0){
                this.mostrarMensajeGuardando();
                let datos = {
                    datos: {
                        select_ubicaciones: this.getField("select_ubicaciones").getValue(),
                        select_operario: this.getField("select_operario").getValue(),
                        sucursal_ingreso:this.sucursal_ingreso,
                        ubicacion:this.fila_seleccionada[0].ubicacion,
                        codigo_turno:this.fila_seleccionada[0].turno+'',
                    }
                }
                this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'grabarpicking', operacion_tipo: 'crear' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.successCrearPicking,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }else{
                this.alertGeneral.toggle(true,'Es necesario seleccionar un registro de la tabla.',"error");
            }
            
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    successCrearPicking(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            if(data.data.mensaje_mostrar!==undefined && data.data.input!==undefined && data.data.input===true){
                this.getField('confirmModalCustom').setTitleAndContent('Operarios', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                        this.mostrarMensajeGuardando();
                        let datos = {
                            datos: {
                                select_ubicaciones: this.getField("select_ubicaciones").getValue(),
                                select_operario: this.getField("select_operario").getValue(),
                                sucursal_ingreso:this.sucursal_ingreso,
                                ubicacion:this.fila_seleccionada[0].ubicacion,
                                codigo_turno:this.fila_seleccionada[0].turno+'',
                                input:'1',
                            }
                        }
                        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'grabarpicking', operacion_tipo: 'crear' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successCrearPicking,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }else{
                //refrescar tabla
                //this.mostrarMensajeAdicional('Operación realiza con éxito.')
                this.alertGeneral.toggle(true, 'Operación realiza con éxito.', 'success');
                this.consultarPicking();
            }
        } else {
            if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        };
    }

    onSelectionChangedPrincipal(){
        this.fila_seleccionada = this.gridOptionsComponentes.api.getSelectedRows();
    }

    onSelectionChangeVacio(){

    }

    traerOperarioCodigo() {
        if(this.getField('codigo_operario').valid()){
            this.mostrarMensajeGenerando();
            let datos = { datos: {
                sucursal_ingreso:this.sucursal_ingreso,
                codigo_operario:this.getField('codigo_operario').getValue(),
            } };
            this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '42_operario', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucesstraerOperarioCodigo,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    sucesstraerOperarioCodigo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('nombre_operario').setValue(data.data[0].nombre);
            this.getField('select_estado_operario').setValue(data.data[0].estado);
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerTurnoCodigo() {
        if(this.getField('codigo_turno').valid()){
            this.mostrarMensajeGenerando();
            let datos = { datos: {
                sucursal_ingreso:this.sucursal_ingreso,
                codigo_turno:this.getField('codigo_turno').getValue(),
            } };
            this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '42_turno', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucesstraerTurnoCodigo,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    sucesstraerTurnoCodigo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('detalle_turno').setValue(data.data[0].detalle);
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerEmpacadorCodigo() {
        if(this.getField('codigo_empacador').valid()){
            this.mostrarMensajeGenerando();
            let datos = { datos: {
                sucursal_ingreso:this.sucursal_ingreso,
                codigo_empacador:this.getField('codigo_empacador').getValue(),
            } };
            this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '42_empacador', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucesstraerEmpacadorCodigo,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    sucesstraerEmpacadorCodigo(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('nombre_empacador').setValue(data.data[0].nombre);
            this.getField('select_ubicaciones2').setValue(data.data[0].bodega);
            this.getField('select_estado_empacadador').setValue(data.data[0].estado);
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerUbicaciones() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '1_ubicaciones', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraeUbicaciones,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraeUbicaciones(data) {
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.codigo_bodega+'';
                dataOp['text'] = item.nombre;
                /* dataOp['campos_cambian'] = { rack: item.id }; */
                opciones.push(dataOp);
            });
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
        this.getField('select_ubicaciones').setOptions(opciones);
        this.getField('select_ubicaciones2').setOptions(opciones);
    }

    traerOperariosPicking() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '1_operarios_picking', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerOperariosPicking,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerOperariosPicking(data) {
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.nombre;
                dataOp['text'] = item.nombre;
                /* dataOp['campos_cambian'] = { rack: item.id }; */
                opciones.push(dataOp);
            });
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
        this.getField('select_operario').setOptions(opciones);
    }

    traerEstados() {
        let datos = { datos: {
        } };
        this.generalFormatPmv = { tipo_servicio: '2', operacion: '1', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraeEstados,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraeEstados(data) {
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.estadosactivos_siglas;
                dataOp['text'] = item.estadosactivos_descripcion;
                /* dataOp['campos_cambian'] = { rack: item.id }; */
                opciones.push(dataOp);
            });
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
        this.getField('select_estado_operario').setOptions(opciones);
        this.getField('select_estado_empacadador').setOptions(opciones);
    }


    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            this.wms_nuevo = data.data.wms_nuevo;

            if(this.wms_nuevo!=='N'){
                this.getField('select_ubicaciones').setVisible(false);
                this.getField('select_operario').setVisible(false);
                this.getField('bt_crear').setVisible(false);
                this.getField('bt_crear_operario').setVisible(false);
                this.getField('bt_crear_turno').setVisible(false);
                this.getField('bt_crear_empacador').setVisible(false);


                this.mostrarMensajeAdicional('OPCIÓN NO AUTORIZADA! (I0084)');
            }
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    consultarPicking() {
        if(this.getField('select_ubicaciones').valid()){
            this.mostrarMensajeGenerando();
            let datos = { datos: {
                sucursal_ingreso:this.sucursal_ingreso,
                select_ubicaciones:this.getField('select_ubicaciones').getValue(),
            } };
            this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: 'pickingbodega', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucessconsultarPicking,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    sucessconsultarPicking(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //dibujar tabla
            this.getField("rejilla").toggle(true);
            this.gridOptionsComponentes["rowData"] = data.data;
            let configCell = new Map();
            configCell.set('turno', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.turno) }, cellStyle: {textAlign:"right"}});            

            this.getField('rejilla').initData(this.gridOptionsComponentes,configCell);
        } else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerOperarios() {
        this.mostrarMensajeGenerando();
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso,
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '1_operarios', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucessTraerOperarios,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    sucessTraerOperarios(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //dibujar tabla
            this.getField("rejilla_operarios").toggle(true);
            this.gridOptionsAux["rowData"] = data.data;
            let configCell = new Map();

            this.getField('rejilla_operarios').initData(this.gridOptionsAux,configCell);
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'No hay datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerTurnos() {
        this.mostrarMensajeGenerando();
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso,
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '1_turno', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucessTurnos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    sucessTurnos(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //dibujar tabla
            this.getField("rejilla_turnos").toggle(true);
            this.gridOptionsAux["rowData"] = data.data;
            let configCell = new Map();

            this.getField('rejilla_turnos').initData(this.gridOptionsAux,configCell);
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'No hay datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerEmpacadores() {
        this.mostrarMensajeGenerando();
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso,
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-definiroperariospicking', operacion: '1_empacador', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucessEmpacadores,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    sucessEmpacadores(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //dibujar tabla
            this.getField("rejilla_empacadores").toggle(true);
            this.gridOptionsAux["rowData"] = data.data;
            let configCell = new Map();

            this.getField('rejilla_empacadores').initData(this.gridOptionsAux,configCell);
        } else if (data.estado_p === 404) {
            this.alertGeneral.toggle(true, 'No hay datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {
        this.getField('rejilla').toggle(false);
        this.fila_seleccionada=[];

    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }



}
FormJaivana.addController("inve-definiroperariospicking", CustomDefinirOperariosPicking);
export default CustomDefinirOperariosPicking